module.exports = __webpack_public_path__ + "img/done.a32df2bc.svg";